import React from 'react'
import { BtnV2, l } from '@manychat/manyui'

import { Heading } from 'apps/aiTextImprover/components/Heading/Heading'
import { RateButton } from 'apps/aiTextImprover/components/RateButton/RateButton'
import { StepLayout } from 'apps/aiTextImprover/components/StepLayout/StepLayout'
import dislike from 'apps/aiTextImprover/components/Steps/RateResultStep/assets/dislike.png'
import like from 'apps/aiTextImprover/components/Steps/RateResultStep/assets/like.png'
import love from 'apps/aiTextImprover/components/Steps/RateResultStep/assets/love.png'
import { AiTextImproverAnalytics } from 'apps/aiTextImprover/lib/analytics'
import { RateType } from 'apps/aiTextImprover/lib/types'
import { useDidMountEffect } from 'utils/commonHooks'

import cm from './RateResultStep.module.css'

interface RateResultStepProps {
  onRatingSubmit: (rating: RateType | null) => void
}

export const RateResultStep = ({ onRatingSubmit }: RateResultStepProps) => {
  useDidMountEffect(() => {
    AiTextImproverAnalytics.logRateStepVisible()
  })

  return (
    <StepLayout
      header={<Heading label={l.translate('Did you like the result?')} />}
      footer={
        <div className={cm.footer}>
          <BtnV2 variant="ghost-primary" onClick={() => onRatingSubmit(null)}>
            {l.translate('Skip')}
          </BtnV2>
        </div>
      }
    >
      <div className={cm.content}>
        <RateButton
          aria-label={l.translate('I did not like it')}
          emoji={dislike}
          keyCode="1"
          onClick={() => onRatingSubmit(RateType.DISLIKE)}
        />

        <RateButton
          aria-label={l.translate('I liked it')}
          emoji={like}
          keyCode="2"
          onClick={() => onRatingSubmit(RateType.LIKE)}
        />

        <RateButton
          aria-label={l.translate('I loved it')}
          emoji={love}
          keyCode="3"
          onClick={() => onRatingSubmit(RateType.LOVE)}
        />
      </div>
    </StepLayout>
  )
}
